export default {
  cleanFilters: 'Clean filteres',
  titleButton: 'Filters',
  filtersTitle: 'Filters',
  cleanFilter: 'Clean filters',
  apply: 'Apply',
  stateFilterLabel: 'State',
  dateFilter: 'Dates',
  dateFieldLabel: 'Date range'
}
